"use strict";
var DESCRIPTORS = require("../internals/descriptors");
var uncurryThis = require("../internals/function-uncurry-this");
var defineBuiltInAccessor = require("../internals/define-built-in-accessor");
var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
if (DESCRIPTORS && !("size" in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, "size", {
    get: function size() {
      var count = 0;
      forEach(this, function() {
        count++;
      });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}
